import { useCallback } from 'react';

export function useScrollRef(formRef: HTMLFormElement) {
  const scrollToTarget = useCallback(
    (behavior = 'smooth') => {
      if (formRef.current) {
        formRef.current.scrollIntoView({
          behavior,
        });
      }
    },
    [formRef]
  );

  return {
    scrollToTarget,
  };
}
